import {
  HttpEvent,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest
} from '@angular/common/http';

import { finalize, Observable } from 'rxjs';
import { inject } from '@angular/core';
import { PreLoaderStore } from '@app/components/header/store/pre-loader.store';

let countRequests = 0;

export const spinnerInterceptor: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const isIconRequest: boolean = request.url.indexOf('assets/icons') !== -1;
  const clonedRequest: HttpRequest<unknown> = request.clone();

  const preLoaderStore = inject(PreLoaderStore);

  if (isIconRequest) {
    return next(clonedRequest);
  }

  countRequests++;

  if (countRequests === 1 && !isIconRequest) {
    setTimeout(() => preLoaderStore.showLoader());
  }

  return next(clonedRequest).pipe(
    finalize(() => {
      countRequests--;

      if (countRequests === 0) {
        setTimeout(() => preLoaderStore.hideLoader());
      }
    })
  );
};
